module.exports = __webpack_public_path__ + "img/img_champoin_bg.78a65b1.svg";